/*if (window.location.pathname.indexOf('/products/') !== -1) {


var stickybtn = $( ".product-sticky-form" ).first()[0];



var stickybtnobserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === "attributes") {
      if(stickybtn.getAttribute('hidden') == null){
var ShopifyChat = $("#dummy-chat-button-iframe")[0];
        if(ShopifyChat === undefined){
  ShopifyChat = $("#ShopifyChat")[0];         
        }

        var bundle_notificator = $("#bundle_notificator")[0];
          ShopifyChat.style.bottom = "80px";
        bundle_notificator.style.bottom = "80px";
        
      }else{
        var ShopifyChat = $("#dummy-chat-button-iframe")[0];
        
        if(ShopifyChat === undefined){
  ShopifyChat = $("#ShopifyChat")[0];         
        }
        var bundle_notificator = $("#bundle_notificator")[0];
          ShopifyChat.style.bottom = "24px";
        bundle_notificator.style.bottom = "24px";
      }
    }
  });
});

stickybtnobserver.observe(stickybtn, {
  attributes: true //configure it to listen to attribute changes
});

}*/

 setInterval(function () {
   let managebtn = $( ".btn-manage__save" ).first()[0];
   let essentialacceptbtn = $( "#essential_accept" ).first()[0];
   if (!managebtn || !essentialacceptbtn) return; /* Rest der alten GDPR-Cookie-App: Elemente gibt es nicht mehr (06.10.2026) */
   let ishidden = managebtn.hasAttribute("hidden");
   if(ishidden){
     essentialacceptbtn.style.display = "none";
   }else{
     essentialacceptbtn.style.display = "inline";
   }
   
 }, 200);
 

/* Cookie-Einstellungen: Links auf #cookie-einstellungen öffnen das Einstellungsfenster von Complianz (07.10.2026) */
(function () {
  function openConsentPrefs() {
    try {
      if (window._iub && _iub.cs && _iub.cs.api && typeof _iub.cs.api.openPreferences === 'function') {
        _iub.cs.api.openPreferences();
        return true;
      }
    } catch (e) {}
    return false;
  }
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href*="cookie-einstellungen"]') : null;
    if (!a) return;
    if (openConsentPrefs()) { ev.preventDefault(); }
  }, true);
  if (window.location.hash === '#cookie-einstellungen') {
    var tries = 0;
    var timer = setInterval(function () {
      if (openConsentPrefs() || ++tries > 40) clearInterval(timer);
    }, 250);
  }
})();
